import { BirthdayData } from '../InitialData/BirthdayData';
import { AnniversaryData } from '../InitialData/AnniversaryData';
import { CustomData } from '../InitialData/CustomData';
import { EarnedData } from '../InitialData/EarnedData';
import { HourlyData } from '../InitialData/HourlyData';
import { MaternityData } from '../InitialData/MaternityData';
import { MedicalData } from '../InitialData/MedicalData';
import { PaternityData } from '../InitialData/PaternityData';
import { SabbaticalData } from '../InitialData/SabbaticalData';
import { SpouseBirthdayData } from '../InitialData/SpouseBirthdayData';
import { UnpaidData } from '../InitialData/UnpaidData';
import { VacationData } from '../InitialData/VacationData';
import CustomLeave from './CustomLeave';
import EarnedLeave from './EarnedLeave';
import HourlyLeave from './HourlyLeave';
import BirthdayLeave from './ImportantDates/BirthdayLeave';
import MarriageAnniversaryLeave from './ImportantDates/MarriageAnniversaryLeave';
import SpouseBirthday from './ImportantDates/SpouseBirthday';
import MaternityLeave from './MaternityLeave';
import MedicalLeave from './MedicalLeave/index';
import PaternityLeave from './PaternityLeave';
import SabbaticalLeave from './SabbaticalLeave';
import UnpaidLeave from './UnpaidLeave';
import VacationLeave from './VacationLeave';

const LeavePlan = [
  {
    leavetypeid: 8,
    Component: BirthdayLeave,
    Reducer: BirthdayData,
  },
  {
    leavetypeid: 5,
    Component: CustomLeave,
    Reducer: CustomData,
  },
  {
    leavetypeid: 1,
    Component: EarnedLeave,
    Reducer: EarnedData,
  },
  {
    leavetypeid: 3,
    Component: HourlyLeave,
    Reducer: HourlyData,
  },
  {
    leavetypeid: 10,
    Component: MarriageAnniversaryLeave,
    Reducer: AnniversaryData,
  },
  {
    leavetypeid: 6,
    Component: MaternityLeave,
    Reducer: MaternityData,
  },
  {
    leavetypeid: 2,
    Component: MedicalLeave,
    Reducer: MedicalData,
  },
  {
    leavetypeid: 7,
    Component: PaternityLeave,
    Reducer: PaternityData,
  },
  {
    leavetypeid: 12,
    Component: SabbaticalLeave,
    Reducer: SabbaticalData,
  },
  {
    leavetypeid: 4,
    Component: UnpaidLeave,
    Reducer: UnpaidData,
  },
  {
    leavetypeid: 11,
    Component: VacationLeave,
    Reducer: VacationData,
  },
  {
    leavetypeid: 9,
    Component: SpouseBirthday,
    Reducer: SpouseBirthdayData,
  },
];
export default LeavePlan;
